import { MediaSummaryCard, type MediaSummaryView } from '../MediaSummaryCard/MediaSummaryCard';
import type { WidgetBlockProps } from '../shared/cardShell';

export type MediaTotalMentionsCardProps = WidgetBlockProps & { view?: MediaSummaryView };

/** Figma `2123:83787` — `mentions` over coverage rows. */
export function MediaTotalMentionsCard(props: MediaTotalMentionsCardProps) {
  return (
    <MediaSummaryCard
      {...props}
      title="Total mentions"
      helpText="Published media stories mentioning your brand during the selected period. Reader posts, comments and replies are excluded."
    />
  );
}
